import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import Card, { Title, Description } from "../Card"

class RadioCard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedOption: ""
    }
  }

  componentDidMount() {
    const { defaultValue } = this.props

    this.setState({ selectedOption: defaultValue })
  }

  componentDidUpdate(prevProps) {
    const { defaultValue } = this.props

    if (prevProps.defaultValue !== defaultValue) {
      this.setDefaultValue()
    }
  }

  setDefaultValue = () => {
    const { defaultValue } = this.props

    this.setState({ selectedOption: defaultValue })
  }

  handleOnChange = e => {
    const { onChange, name } = this.props

    this.setState({ selectedOption: e.currentTarget.value })

    onChange(name, "value", e.currentTarget.value)
  }

  render() {
    const { name, options, className, classNameActive } = this.props

    const { selectedOption } = this.state

    return (
      <div className="radio-card">
        {options.map(
          (
            { title, description, value, icon, iconLight, iconTitle },
            index
          ) => {
            const key = `${name}_${index}`

            return (
              <label htmlFor={key} key={key}>
                <input
                  id={key}
                  type="radio"
                  value={value}
                  name={name}
                  onChange={this.handleOnChange}
                  checked={selectedOption === value}
                />
                <Card
                  className={[
                    className,
                    selectedOption === value ? classNameActive : ""
                  ].join(" ")}
                >
                  <div className="row">
                    <div className="col-lg-7">
                      <Title>{title}</Title>
                      <Description>{description}</Description>
                    </div>
                    <div className="col-lg-5">
                      <div className="card_icon">
                        <img
                          src={selectedOption === value ? iconLight : icon}
                          alt={iconTitle}
                          title={iconTitle}
                        />
                      </div>
                    </div>
                  </div>
                </Card>
              </label>
            )
          }
        )}
      </div>
    )
  }
}

RadioCard.propTypes = {
  name: propTypes.string.isRequired,
  options: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string,
      description: propTypes.string,
      icon: propTypes.string,
      iconTitle: propTypes.string
    })
  ).isRequired,
  onChange: propTypes.func.isRequired,
  defaultValue: propTypes.oneOfType([propTypes.string, propTypes.number]),
  className: propTypes.string,
  classNameActive: propTypes.string
}

RadioCard.defaultProps = {
  defaultValue: "",
  className: "",
  classNameActive: ""
}

export default RadioCard
